import {
  Button,
  Text,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Switch,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "../../Api/ApiService";
import { StyledInputGroup } from "./styles";
import { getUser } from "../../context/token";
import Alert from "sweetalert2";

interface IInputsCadastroAnimal {
  nome: string;
  raca: string;
  tipo: string;
  sexo: string;
  foto: File | any;
  descricao: string;
  disponibilidade: Boolean;
  castrado: Boolean;
}

type entrada = {
  onClose: () => void;
  isOpen: boolean;
  animal_id?: string;
  tipo_animal?: string;
  foto?: Buffer;
  nome?: string;
  raca?: string;
  sexoA?: string;
  descricao?: string;
  disponibilidade?: boolean;
  castradoA?: boolean;
  modo: string;
};

type inforAnimais = {
  animal_id: string;
  tipo_animal: string;
  nome: string;
  raca: string;
  sexoA: string;
  descricao: string;
  disponibilidade: boolean;
  castradoA: boolean;
};

const ModalAnimal = ({
  onClose,
  modo,
  isOpen,
  animal_id,
  tipo_animal,
  foto,
  nome,
  raca,
  sexoA,
  descricao,
  castradoA,
  disponibilidade,
}: entrada) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset: resetForm,
  } = useForm<IInputsCadastroAnimal>();

  const [tipo, setTipo] = useState("");
  const [sexo, setSexo] = useState("");
  const [disponivel, setDisponivel] = useState(false);
  const [castrado, setCastrado] = useState(false);

  // const { role } = getUser();
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  async function onSubmitModal(data: IInputsCadastroAnimal) {
    try {
      const dados = new FormData();
      if (data.foto.length > 0) {
        dados.append("foto", data.foto.item(0));
        dados.append("nome", data.nome);
        dados.append("tipo", tipo);
        dados.append("raca", data.raca);
        dados.append("sexo", sexo);
        dados.append("descricao", data.descricao);
        dados.append("disponivel", String(disponivel));
        dados.append("castrado", String(castrado));
      } else {
        dados.append("nome", data.nome);
        dados.append("tipo", tipo);
        dados.append("raca", data.raca);
        dados.append("sexo", sexo);
        dados.append("descricao", data.descricao);
        dados.append("disponivel", String(disponivel));
        dados.append("castrado", String(castrado));
      }

      if (modo == "editar") {
        const result = await api.patch(
          `/animais/${animal_id}?token=${process.env.REACT_APP_TOKEN_API}`,
          dados
        );

        toast({
          title: "Edição realizada",
          description: result.data.message,
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });

        window.location.reload();
      } else {
        const result = await api.post(
          `/animais?token=${process.env.REACT_APP_TOKEN_API}`,
          dados
        );
        if (result.status === 201) {
          Alert.fire({
            toast: true,
            icon: "success",
            text: result.data.message,
            confirmButtonText: "OK",
            confirmButtonColor: "#3f3d56",
          }).then(() => {
            window.location.reload();
          });
        }

        onClose();
        resetForm();
      }
    } catch (error: Error | any) {
      console.log(error);
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  useEffect(() => {
    if (modo == "editar" && nome && raca && tipo_animal && sexoA && foto) {
      if (!descricao) {
        descricao = "";
      }
      if (!disponibilidade) {
        disponibilidade = false;
      }
      if (!castradoA) {
        castradoA = false;
      }
      setTipo(tipo_animal);
      setSexo(sexoA);
      setCastrado(castradoA);
      setDisponivel(disponibilidade);
      setValue("nome", nome);
      setValue("raca", raca);
      setValue("descricao", descricao);
    }
  }, [
    modo,
    setValue,
    nome,
    raca,
    tipo_animal,
    sexoA,
    disponibilidade,
    castradoA,
    descricao,
    foto,
  ]);

  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
      size={"2xl"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          display={"flex"}
          justifyContent={"center"}
          color={"#3F3D56"}
          fontWeight={"bold"}
          fontSize={25}
        >
          {modo == "editar" ? "Editar animal" : "Cadastro do animal"}
        </ModalHeader>
        <form
          encType="multipart/form-data"
          onSubmit={handleSubmit(onSubmitModal)}
        >
          <ModalBody>
            <StyledInputGroup gap={5}>
              <FormControl>
                <InputGroup>
                  <FormLabel fontSize={16}>Nome:</FormLabel>
                  <Input
                    variant={"filled"}
                    border={"1px solid #B0BEC5"}
                    size={"sm"}
                    borderRadius={"5px"}
                    {...register("nome", {
                      required: "Campo obrigatório",
                    })}
                  />
                </InputGroup>
                {errors.nome && (
                  <Text ml={"4rem"} mt={0} fontSize={11} color={"#c03333"}>
                    {errors.nome.message}
                  </Text>
                )}
              </FormControl>

              <FormControl>
                <InputGroup gap={2}>
                  <FormLabel fontSize={16}>Raça:</FormLabel>
                  <Input
                    variant={"filled"}
                    border={"1px solid #B0BEC5"}
                    size={"sm"}
                    borderRadius={"5px"}
                    {...register("raca", {
                      required: "Campo obrigatório",
                    })}
                  />
                </InputGroup>
                {errors.raca && (
                  <Text ml={"4rem"} mt={0} fontSize={11} color={"#c03333"}>
                    {errors.raca.message}
                  </Text>
                )}
              </FormControl>
            </StyledInputGroup>

            <StyledInputGroup gap={5} mt={5}>
              <FormControl>
                <InputGroup>
                  <FormLabel fontSize={16}>Tipo:</FormLabel>
                  <Select
                    placeholder="Tipo do animal"
                    variant={"filled"}
                    size={"sm"}
                    w={"100%"}
                    marginLeft={"10px"}
                    border={"1px solid #B0BEC5"}
                    borderRadius={"5px"}
                    value={tipo}
                    isRequired
                    onChange={(e) => setTipo(e.target.value)}
                  >
                    <option value="Cachorro">Cachorro</option>
                    <option value="Gato">Gato</option>
                  </Select>
                </InputGroup>
              </FormControl>

              <FormControl>
                <InputGroup gap={2}>
                  <FormLabel fontSize={16}>Sexo:</FormLabel>
                  <Select
                    placeholder="Sexo do animal"
                    variant={"filled"}
                    size={"sm"}
                    border={"1px solid #B0BEC5"}
                    borderRadius={"5px"}
                    value={sexo}
                    isRequired
                    onChange={(e) => {
                      setSexo(e.target.value);
                    }}
                  >
                    <option value="Macho">Macho</option>
                    <option value="Fêmea">Fêmea</option>
                  </Select>
                </InputGroup>
              </FormControl>
            </StyledInputGroup>

            <StyledInputGroup mt={5} gap={5}>
              <FormControl>
                <InputGroup gap={2}>
                  <FormLabel fontSize={16}>Foto:</FormLabel>
                  {modo == "editar" ? (
                    <Input
                      type={"file"}
                      size={"sm"}
                      border={"1px solid #B0BEC5"}
                      borderRadius={"5px"}
                      accept={".png, .svg, .jpeg, .jpg"}
                      className="input-file"
                      {...register("foto")}
                    />
                  ) : (
                    <Input
                      type={"file"}
                      size={"sm"}
                      border={"1px solid #B0BEC5"}
                      borderRadius={"5px"}
                      accept={".png, .svg, .jpeg, .jpg"}
                      className="input-file"
                      isRequired
                      {...register("foto", { required: "Campo Obrigatório" })}
                    />
                  )}
                </InputGroup>
              </FormControl>

              <FormControl>
                <InputGroup>
                  <FormLabel fontSize={16}>Descrição:</FormLabel>
                  <Input
                    variant={"filled"}
                    border={"1px solid #B0BEC5"}
                    size={"sm"}
                    borderRadius={"5px"}
                    {...register("descricao")}
                  />
                </InputGroup>
                {errors.descricao && (
                  <Text ml={"5.6rem"} mt={0} fontSize={11} color={"#c03333"}>
                    {errors.descricao.message}
                  </Text>
                )}
              </FormControl>
            </StyledInputGroup>

            <StyledInputGroup mt={5} gap={5}>
              <InputGroup>
                <FormLabel fontSize={16}>Disponível para adoção?</FormLabel>
                <Switch
                  size={"lg"}
                  colorScheme={"teal"}
                  isChecked={disponivel}
                  onChange={() => {
                    setDisponivel(!disponivel);
                  }}
                />
              </InputGroup>

              <InputGroup>
                <FormLabel fontSize={16}>Castrado</FormLabel>
                <Switch
                  size={"lg"}
                  colorScheme={"teal"}
                  isChecked={castrado}
                  onChange={() => {
                    setCastrado(!castrado);
                  }}
                />
              </InputGroup>
            </StyledInputGroup>
          </ModalBody>
          <ModalFooter>
            <InputGroup gap={8} display={"contents"}>
              {modo == "editar" ? (
                <Button
                  w={40}
                  h={8}
                  border={"1px solid #c03333"}
                  color={"#c03333"}
                  fontWeight={"medium"}
                  backgroundColor={"white"}
                  marginRight={"5"}
                  onClick={() => {
                    onClose();
                  }}
                >
                  Cancelar
                </Button>
              ) : (
                <Button
                  w={40}
                  h={8}
                  border={"1px solid #c03333"}
                  color={"#c03333"}
                  fontWeight={"medium"}
                  backgroundColor={"white"}
                  marginRight={"5"}
                  onClick={() => {
                    resetForm();
                    onClose();
                  }}
                >
                  Cancelar
                </Button>
              )}

              <Button
                type="submit"
                w={40}
                h={8}
                border={"1px solid #044549"}
                color={"#044549"}
                backgroundColor={"white"}
                fontWeight={"medium"}
              >
                Salvar
              </Button>
            </InputGroup>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export { ModalAnimal };
